import React, { useEffect, useState, useRef } from 'react';
import './Home.css';
import { useNavigate } from 'react-router-dom';
import UserManagerDialog from '../components/UserManagerDialog';
import UserDrawer from '../components/UserDrawer';
import '../components/UserManagerDialog.css';
import '../components/UserDrawer.css';
import CustomOrderPage from './CustomOrderPage';

export default function Home() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userDialogOpen, setUserDialogOpen] = useState(false);
  const [userDrawerOpen, setUserDrawerOpen] = useState(false);
  const [customOrderOpen, setCustomOrderOpen] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const categoriesListRef = useRef(null);
  const autoScrollRef = useRef(null);
  const [autoScroll, setAutoScroll] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    fetch('https://devbite.vercel.app/api/cakedoctorcategories')
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch categories');
        return res.json();
      })
      .then((data) => {
        setCategories(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  const handleLogin = (userObj) => {
    localStorage.setItem('user', JSON.stringify(userObj));
    setUser(userObj);
  };

  const handleProfileClick = () => {
    if (user) setUserDrawerOpen(true);
    else setUserDialogOpen(true);
  };
  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
    setUserDrawerOpen(false);
  };
  const handleOrdersClick = () => {
    if (!user) setUserDialogOpen(true);
    else navigate('/myorders');
  };
  const handleCustomClick = () => {
    if (!user) setUserDialogOpen(true);
    else navigate('/custom');
  };
  const handleOrderCreated = () => {
    setCustomOrderOpen(false);
    // Optionally show success message or redirect
  };

  // Auto-scroll effect
  useEffect(() => {
    if (!categories.length || !autoScroll) return;
    const list = categoriesListRef.current;
    if (!list) return;
    let frame;
    let lastScrollLeft = list.scrollLeft;
    function step() {
      if (!autoScroll) return;
      if (list.scrollLeft < list.scrollWidth - list.clientWidth) {
        list.scrollLeft += 0.4; // Slow speed
        lastScrollLeft = list.scrollLeft;
      } else {
        list.scrollLeft = 0;
        lastScrollLeft = 0;
      }
      frame = requestAnimationFrame(step);
    }
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [categories, autoScroll]);

  // Pause auto-scroll on user interaction
  useEffect(() => {
    const list = categoriesListRef.current;
    if (!list) return;
    const stopScroll = () => setAutoScroll(false);
    const resumeScroll = () => setAutoScroll(true);
    list.addEventListener('mousedown', stopScroll);
    list.addEventListener('touchstart', stopScroll);
    list.addEventListener('wheel', stopScroll);
    list.addEventListener('pointerdown', stopScroll);
    list.addEventListener('mouseleave', resumeScroll);
    list.addEventListener('touchend', resumeScroll);
    list.addEventListener('mouseup', resumeScroll);
    return () => {
      list.removeEventListener('mousedown', stopScroll);
      list.removeEventListener('touchstart', stopScroll);
      list.removeEventListener('wheel', stopScroll);
      list.removeEventListener('pointerdown', stopScroll);
      list.removeEventListener('mouseleave', resumeScroll);
      list.removeEventListener('touchend', resumeScroll);
      list.removeEventListener('mouseup', resumeScroll);
    };
  }, [categoriesListRef]);

  return (
    <div className="home-root">
      {/* Header Section */}
      <div className="header-pic-container">
        <img src="/cover.jpeg" alt="Header" className="header-pic" />
        {user ? (
          <button className="profile-btn profile-avatar-btn" onClick={handleProfileClick}>
            <img src={user.photoURL} alt="User" className="profile-avatar" />
          </button>
        ) : (
          <button className="profile-btn" onClick={handleProfileClick}>
            Profile
          </button>
        )}
        <div className="header-text">
          <div className="header-title">Celebrate with Our Delights</div>
        </div>
      </div>
      {/* Navigation */}
      <nav className="top-nav">
        <span>LearnBaking</span>
        <span>Earn Comission</span>
        <span>About us</span>
      </nav>
      {/* Categories */}
      <section className="categories-section">
        <div className="categories-header">
          <span className="categories-title">Categories</span>
          <span className="view-all">View All <b>+</b></span>
        </div>
        <div className="categories-list" ref={categoriesListRef} style={{ overflowX: 'auto', scrollBehavior: 'smooth', whiteSpace: 'nowrap' }}>
          {loading ? (
            <div className="category-card" style={{ minWidth: 170 }}>
              Loading...
            </div>
          ) : error ? (
            <div className="category-card" style={{ minWidth: 170, color: 'red' }}>
              {error}
            </div>
          ) : categories.length === 0 ? (
            <div className="category-card" style={{ minWidth: 170 }}>
              No categories found
            </div>
          ) : (
            categories.map((cat, idx) => (
              <div
                className="category-card"
                key={cat.id || idx}
                onClick={() => navigate(`/category/${cat.id}/${encodeURIComponent(cat.name)}`)}
                style={{ cursor: 'pointer' }}
              >
                <img src={cat.imageUrl} alt={cat.name} className="category-img" />
                <div className="category-name">{cat.name}</div>
              </div>
            ))
          )}
        </div>
      </section>
      {/* Bottom Navigation */}
      <nav className="bottom-nav" style={{ position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 100, background: '#232323', boxShadow: '0 -2px 12px rgba(232,93,158,0.05)', color: '#fff', display: 'flex', justifyContent: 'space-around', height: '44px', alignItems: 'center' }}>
        <div className="nav-item active" style={{ background: '#eaeaea', color: '#232323', borderRadius: '14px', padding: '6px 18px', fontWeight: 700 }}>Home</div>
        <div className="nav-item" style={{ color: '#fff' }} onClick={handleOrdersClick}>Orders</div>
        <div className="nav-item" style={{ color: '#fff' }} onClick={handleCustomClick}>Custom</div>
      </nav>
      <UserManagerDialog open={userDialogOpen} onClose={() => setUserDialogOpen(false)} onLogin={handleLogin} />
      <UserDrawer user={user} open={userDrawerOpen} onClose={() => setUserDrawerOpen(false)} onLogout={handleLogout} />
    </div>
  );
}
